import React from 'react';

import {
  Wifi1Icon,
  Wifi2Icon,
  Wifi3Icon,
  Wifi4Icon,
  WifiOff,
} from '../../../assets';
import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface GetWifiSignalIconProps extends React.SVGProps<SVGSVGElement> {
  rssi: number | null | undefined;
}
/* Connection RSSI strength (-30 is Perfect -90 is bad) */
export const GetWifiSignalIcon = (props: GetWifiSignalIconProps) => {
  const { rssi, ...rest } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const normalColor = theme.palette.success.main;
  const defaultProps = { height: '100%', color: normalColor };
  const combinedProps = { ...defaultProps, ...rest };
  let icon = null;

  const invalidRSSI = rssi === null || rssi === undefined || isNaN(rssi);
  if (invalidRSSI) {
    icon = <WifiOff {...combinedProps} />;
  } else if (rssi <= -85) {
    icon = <Wifi1Icon {...combinedProps} />;
  } else if (rssi <= -70) {
    icon = <Wifi2Icon {...combinedProps} />;
  } else if (rssi <= -50) {
    icon = <Wifi3Icon {...combinedProps} />;
  } else {
    icon = <Wifi4Icon {...combinedProps} />;
  }
  return (
    <Box
      title={
        invalidRSSI
          ? t('device.controlUnit.tooltip.no_signal') ?? ''
          : `${rssi}`
      }
    >
      {icon}
    </Box>
  );
};
